import React from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Content from '../../../layout/Content';

import { MANUAL_VOUCHER_PAYMENT_PATH } from '../../../../config/paths';

import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import { reconcileManualVoucherPayments } from '../../../../actions/corporate/ManualVoucherPayment';

import ManualVoucherPaymentReconciliationForm from './ManualVoucherPaymentReconciliationForm';

const ManualVoucherPaymentReconciliation = ({
  breadcrumbs,
  dispatchReconcileManualVoucherPayments,
}) => {
  const onSubmit = async (formValues) => {
    const { manualVoucherId, selectedPaymentIds } = formValues;

    return dispatchReconcileManualVoucherPayments({
      manualVoucherId,
      manualVoucherPaymentIds: selectedPaymentIds,
    });
  };

  const content = (
    <ManualVoucherPaymentReconciliationForm onSubmit={onSubmit} />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Conciliación de Pagos"
      subtitle="Conciliar pagos con comprobantes manuales"
      content={content}
    />
  );
};

ManualVoucherPaymentReconciliation.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchReconcileManualVoucherPayments: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchReconcileManualVoucherPayments: reconcileManualVoucherPayments,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Pagos de Comprobantes Manuales',
      href: MANUAL_VOUCHER_PAYMENT_PATH,
    },
    {
      text: 'Conciliación',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualVoucherPaymentReconciliation);
